// extracted by mini-css-extract-plugin
export default {"LevelItem":"LevelItem_LevelItem__NoRQc","Buttons":"LevelItem_Buttons__4T6YR"};